import Button from '@wconcept/wconcept-ui-renewal/components/atoms/Button';

import * as S from './style';

interface IProps {
  /** type */
  type?: 'balance' | 'rightBig' | undefined;
  /** borderTop */
  borderTop?: boolean;
  /** secondaryBtn */
  secondaryBtn?: {
    text?: React.ReactNode;
    onClick?: () => void;
  };
  /** primaryBtn */
  primaryBtn: {
    text: React.ReactNode;
    disabled?: boolean;
    onClick: () => void;
  };
  /** isIPhoneXApp */
  isIPhoneXApp?: boolean;
  /** className */
  className?: string;
}

const ModalGroupBtn = ({
  type = 'balance',
  borderTop = false,
  primaryBtn,
  secondaryBtn,
  isIPhoneXApp,
  className,
}: IProps) => (
  <S.ModalGroupBtn
    className={`modal-group-btn ${isIPhoneXApp ? 'is-old-app-iphonex' : ''} ${
      borderTop ? 'border-top' : ''
    }`}
    $type={type}
  >
    {secondaryBtn && (
      <Button className="btn-secondary" onClick={secondaryBtn.onClick}>
        {secondaryBtn.text}
      </Button>
    )}
    {primaryBtn && (
      <Button
        className={`btn-primary ${className || ''}`}
        disabled={primaryBtn.disabled}
        onClick={primaryBtn.onClick}
      >
        {primaryBtn.text}
      </Button>
    )}
  </S.ModalGroupBtn>
);

export default ModalGroupBtn;
